
import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Team from "../pages/team/page";
import ProjectDetail from "../pages/project-detail/page";
import PrivacyPolicy from "../pages/privacy/page";
import TermsOfService from "../pages/terms/page";

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/team',
    element: <Team />
  },
  {
    path: '/project/:id',
    element: <ProjectDetail />
  },
  {
    path: '/privacy',
    element: <PrivacyPolicy />
  },
  {
    path: '/terms',
    element: <TermsOfService />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
